<script setup lang="ts">
    import { computed } from 'vue';

    type AccessRequestOption = {
        label: string;
        description: string;
        icon: string;
        href: string;
    };

    const accessRequestOptions: AccessRequestOption[] = [
        {
            label: 'View access',
            description: 'Browse and read library content',
            icon: 'eye-outline',
            href: 'https://accessit.equinor.com/Search/Search?term=View+%28TIE+-+COMMON+LIB%29'
        },
        {
            label: 'Code edit access',
            description: 'Add and edit codes and library content',
            icon: 'pencil-outline',
            href: 'https://accessit.equinor.com/Search/Search?term=Code+Edit+%28TIE+-+COMMON+LIB%29'
        }
    ];

    const requestAccessUrl = computed(() => window.config?.reportErrorUrl);
</script>

<template>
    <section class="section">
        <div class="no-access-card">
            <div class="has-text-centered">
                <b-icon
                    size="is-large"
                    icon="lock-alert"
                    class="mb-4" />
                <h1 class="title is-4">
                    No access to Common Library
                </h1>
                <p class="mb-5">
                    You do not have any role granting access to Common Library.
                    Access must be requested from AccessIT.
                </p>
            </div>
            <a
                v-for="option in accessRequestOptions"
                :key="option.label"
                class="access-option mb-3 p-4"
                :href="option.href"
                target="_blank">
                <span class="access-option-icon">
                    <b-icon :icon="option.icon" />
                </span>
                <span class="access-option-text">
                    <span class="has-text-weight-semibold">{{ option.label }}</span>
                    <span class="has-text-grey">{{ option.description }}</span>
                </span>
                <b-icon icon="open-in-new" />
            </a>
            <p
                v-if="requestAccessUrl"
                class="has-text-centered mt-5">
                For other issues, <a
                    :href="requestAccessUrl"
                    target="_blank">request help in ServiceNow</a>.
            </p>
        </div>
    </section>
</template>

<style scoped>
.no-access-card {
    max-width: 40rem;
    margin: 0 auto;
    padding: 2rem;
    border-radius: 0.5rem;
    background-color: var(--eq-bg-highlight);
}
.access-option {
    display: flex;
    align-items: center;
    gap: 1rem;
    background-color: var(--eq-white);
    border-radius: 0.5rem;
    color: inherit;
    text-decoration: none;
}
.access-option:hover {
    background-color: var(--eq-additional-3);
}
.access-option-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: none;
    width: 3rem;
    height: 3rem;
    border-radius: 0.5rem;
    background-color: var(--eq-additional-3);
    color: var(--eq-north-sea-3);
}
.access-option-text {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}
</style>
